import React from "react";
import PropTypes from "prop-types";
import Icon from "../../../../../atoms/icon";
import styles from "./styles.m.css";
const Attachment = ({ element }) => {
  return (
    <a className="story-element-file__link" target="_blank" rel="noopener noreferrer" href={element.url} download>
      <Icon type={"download"} className={styles["download"]} /> download
    </a>
  );
};

Attachment.propTypes = {
  element: PropTypes.shape({
    url: PropTypes.string
  })
};

export { Attachment };
